import { Component } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent {
  constructor() {
    this.initializeEtiktoTheme();
  }

    private initializeEtiktoTheme() {
    // Asegurar que el tema se aplique correctamente
    document.documentElement.setAttribute('data-theme', 'etikto-light');
    document.body.classList.add('etikto-theme', 'light-theme');
    
    // Prevenir dark mode del sistema
    if (matchMedia('(prefers-color-scheme: dark)').matches) {
      document.body.classList.remove('dark');
      document.body.classList.add('light');
    }
  }
}
